var React = require('react');

function IcnMail (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 1.2052H36.4033V26.4137H1V1.2052Z","stroke":"black","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M36.4034 1.2052L20.8408 17.5427C19.6605 18.7995 17.743 18.7995 16.5628 17.5427L1.00012 1.2052","stroke":"black","strokeMiterlimit":"10","key":1}),React.createElement("path",{"d":"M22.8322 15.5468L36.4034 26.4877","stroke":"black","strokeMiterlimit":"10","key":2}),React.createElement("path",{"d":"M14.6453 15.5468L1.00012 26.4877","stroke":"black","strokeMiterlimit":"10","key":3})]);
}

IcnMail.defaultProps = {"width":"37","height":"27","viewBox":"0 0 37 27","fill":"none"};

module.exports = IcnMail;

IcnMail.default = IcnMail;
